import { Component } from '@angular/core';
import { CertificationDeleteModalComponent } from './certification-delete-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from 'services/profile/profile.service';
import { MessageQueryService } from '@certemy/ui-components';
import { of, throwError } from 'rxjs';
import _get from 'lodash-es/get';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'cm-workflow-delete-modal',
  templateUrl: './workflow-delete-modal.component.html',
  styleUrls: ['./certification-delete-modal.component.scss'],
})
export class WorkflowDeleteModalComponent extends CertificationDeleteModalComponent {
  constructor(
    protected ngbActiveModal: NgbActiveModal,
    protected profileService: ProfileService,
    protected messageQueryService: MessageQueryService,
  ) {
    super(ngbActiveModal, profileService, messageQueryService);
  }

  private VALIDATION_ERROR_CODES = {
    COMPLETED_REGISTRATION_PHASE: 'COMPLETED_REGISTRATION_PHASE',
  };
  showRegistrationError: boolean = false;
  readonly supportLink = 'https://www.certemy.com/contact-support';
  readonly supportLinkShort = this.supportLink.replace(/^https?:\/\//, '');

  onDeleteCertificate() {
    this.profileService
      .deleteUserCertification(this.certificationInstanceId)
      .pipe(
        catchError(err => {
          const { body } = err;
          if (body) {
            const { code_name, error_details } = body;
            if (
              code_name === 'VALIDATION_ERROR' &&
              _get(error_details, 'code', []).includes(this.VALIDATION_ERROR_CODES.COMPLETED_REGISTRATION_PHASE)
            ) {
              return of(this.VALIDATION_ERROR_CODES.COMPLETED_REGISTRATION_PHASE);
            }
          }
          return throwError(err);
        }),
      )
      .subscribe(resp => {
        switch (resp) {
          case this.VALIDATION_ERROR_CODES.COMPLETED_REGISTRATION_PHASE:
            this.showRegistrationError = true;
            return;
          default:
            this.messageQueryService.addMessage('Testing workflow was deleted successfully');
            this.ngbActiveModal.close();
        }
      });
  }
}
